import React, { useId } from "react";
import PropTypes from "prop-types";

const DemoIcon = ({ selected, width, height, className, ...props }) => {
  const id = useId().replace(/:/g, "");
  const clipId = `demo-clip-${id}`;

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M12 17V21M8.00003 21H16M15.033 9.44C15.2329 9.55566 15.356 9.76908 15.356 10C15.356 10.2309 15.2329 10.4443 15.033 10.56L10.968 12.912C10.7682 13.0276 10.5219 13.0276 10.322 12.912C10.1222 12.7964 9.99942 12.5828 10 12.352V7.648C9.99963 7.41747 10.1223 7.20424 10.3218 7.08871C10.5213 6.97318 10.7673 6.97291 10.967 7.088L15.033 9.44ZM4.00003 3H20C21.1039 3 22 3.89617 22 5V15C22 16.1038 21.1039 17 20 17H4.00003C2.8962 17 2.00003 16.1038 2.00003 15V5C2.00003 3.89617 2.8962 3 4.00003 3Z"
          stroke="white"
          strokeOpacity={selected ? 1 : 0.5}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

DemoIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

DemoIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default DemoIcon;
